import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import TabsHeader from 'components/TabsHeader/TabsHeader';
import { usePerms } from 'contexts/PermsContext';
import { GetPermListForRole } from 'data/permData';
import GetWidgetData from 'data/widgetData/widgetData.js';
import { useEffect, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { IconContext } from 'react-icons';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useGetAllAvailableDeviceTypesQuery } from 'services/devices/devices.api';
import { getWorkplaceMembers } from 'services/organization/organization.service';
import { getGlobalWidgetPermList } from 'services/perms/perms.service';
import { getRole } from 'services/roles/roles.service';
import { getVisibleUsers } from 'utils/roleUtils';
import '../Dashboard/assets/Dashboard.css';
import DashboardViewTab from './Components/DashboardViewTab';
import DetailsTab from './Components/DetailsTab';
import PermissionsTab from './Components/PermissionsTab';

export default function ViewRole() {
  const navigate = useNavigate();
  const { data: deviceTypes = {} } = useGetAllAvailableDeviceTypesQuery();
  const [permList, setPermList] = useState([]);
  let widgetData = GetWidgetData();
  const perms = usePerms();
  const [params, setParams] = useSearchParams();
  const TAB_OPTIONS = ['Role Details', 'Permissions', 'Dashboard View'];
  const [formData, setFormData] = useState({
    roleName: '',
    members: [],
    initialMembers: [],
    permissions: permList.map(() => false),
    layout: [],
  });
  const [result, setResult] = useState('');
  const [membersList, setMembersList] = useState([]);

  useEffect(() => {
    (async () => {
      let permList = [];

      const deviceTypeArr = Object.keys(deviceTypes).flatMap((systemType) => {
        return Object.keys(deviceTypes[systemType]).flatMap((deviceType) => {
          if (
            Object.keys(deviceTypes[systemType][deviceType]).length > 0 &&
            !Object.keys(deviceTypes[systemType][deviceType]).includes('validDevices')
          )
            return Object.keys(deviceTypes[systemType][deviceType]).map(
              (subType) => systemType + ' ' + deviceType + '_' + subType,
            );
          else return systemType + ' ' + deviceType;
        });
      });

      const newPerms = GetPermListForRole(deviceTypeArr);
      permList = newPerms;

      const globalWidgetPermList = (await getGlobalWidgetPermList()).data.result;

      permList = permList.filter((filter, index) => {
        if (filter.linked > 0) {
          return globalWidgetPermList.permissions.includes(
            permList[index + 1].name.replace(/\s/g, '').replace(/\//g, '-').replace(/:/g, '_'),
          );
        } else {
          return globalWidgetPermList.permissions.includes(
            filter.name.replace(/\s/g, '').replace(/\//g, '-').replace(/:/g, '_'),
          );
        }
      });

      setPermList([...permList]);

      let newWidgetList = {};
      Object.keys(widgetData).forEach((key) => {
        if (globalWidgetPermList.widgetList.includes(parseInt(key))) {
          newWidgetList = { ...newWidgetList, [key]: widgetData[key] };
        }
      });

      widgetData = newWidgetList;

      const userData = await getWorkplaceMembers(getVisibleUsers(perms)).then((res) => {
        const temp = [...res.data.result];
        temp.map((item) => (item = { ...item, selected: false }));
        return [...temp];
      });

      await getRole(params.get('roleid')).then((result) => {
        const parsedPerms = JSON.parse(result.data.result[0].role_perms);

        const permissions = permList.map(() => false);

        Object.keys(parsedPerms).map((key) => {
          const str = parsePermName(key);
          const index = permList.findIndex((item) => item.name === str);
          permissions[index] = parsedPerms[key];
        });

        const initUsers = [];
        const temp = [];

        for (let i = 0; i < userData.length; i++) {
          const userRoles = JSON.parse(userData[i].roles);
          if (userRoles.includes(parseInt(params.get('roleid')))) {
            initUsers.push({ ...userData[i] });
            temp.push({ ...userData[i], selected: true });
          } else {
            temp.push({ ...userData[i] });
          }
        }

        setMembersList([...temp]);
        setFormData({
          ...formData,
          roleName: result.data.result[0].role_name,
          permissions: [...permissions],
          initialMembers: [...initUsers],
          layout: JSON.parse(result.data.result[0].widget_list),
        });
      });
    })();
  }, []);

  const getCurrentTabIndex = () => {
    const tabParam = params.get('tab');
    const matchedIndex = TAB_OPTIONS.findIndex(
      (option) => option.toLowerCase() === tabParam?.toLowerCase(),
    );
    return matchedIndex === -1 ? 0 : matchedIndex;
  };

  const currentTabIndex = getCurrentTabIndex();
  const updateTabParam = (nextIndex, replace = false) => {
    const newParams = new URLSearchParams(params.toString());
    newParams.set('tab', TAB_OPTIONS[nextIndex]);
    setParams(newParams, { replace });
  };

  const renderTab = () => {
    if (!perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewRoles'])) return;

    switch (currentTabIndex) {
      case 0:
        return (
          <DetailsTab
            formData={formData}
            setFormData={setFormData}
            membersList={membersList}
            setMembersList={setMembersList}
            widgetData={widgetData}
            permList={permList}
            roleid={params.get('roleid')}
            edit={false}
          />
        );
      case 1:
        return (
          <PermissionsTab
            formData={formData}
            setFormData={setFormData}
            widgetData={widgetData}
            permList={permList}
            edit={false}
            roleid={params.get('roleid')}
          />
        );
      case 2:
        if (!perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewAsRole'])) return;
        return (
          <DashboardViewTab
            formData={formData}
            setFormData={setFormData}
            widgetData={widgetData}
            permList={permList}
            edit={false}
          />
        );
      default:
        return (
          <DetailsTab
            formData={formData}
            setFormData={setFormData}
            membersList={membersList}
            setMembersList={setMembersList}
            widgetData={widgetData}
            permList={permList}
            roleid={params.get('roleid')}
            edit={false}
          />
        );
    }
  };

  const onBack = () => {
    if (currentTabIndex === 0) navigate('/system/rolemanager');
    else updateTabParam(currentTabIndex - 1);
  };

  const onNext = () => {
    if (currentTabIndex === TAB_OPTIONS.length - 1) {
      navigate('/system/rolemanager');
    } else {
      updateTabParam(currentTabIndex + 1);
    }
  };

  const parsePermName = (permName) => {
    let str = permName.replace(/-/g, '/').replace(/_/g, ':');

    // Protect USGS from being split into 'U S G S'
    let restoreUSGS = false;
    if (str.includes('USGS')) {
      str = str.replace(/USGS/g, 'Usgs');
      restoreUSGS = true;
    }

    let characters = str.split('');
    let result = [];

    characters.forEach((char, index) => {
      if (
        char === char.toUpperCase() &&
        index > 0 &&
        !(char === 'I' && characters[index - 1] === 'A') &&
        !(char === 'A' && characters[index - 1] === 'c') &&
        !(char === 'W' && characters[index - 1] === 'A') &&
        !(char === 'A' && characters[index - 1] === 'W') &&
        !(char === 'R' && characters[index - 1] === 'A') &&
        !(char === 'E' && characters[index - 1] === 'R')
      ) {
        result.push(' ');
      }
      result.push(char);
    });

    str = result.join('');
    if (restoreUSGS) str = str.replace(/Usgs/g, 'USGS'); //Restore USGS if it was changed
    return str;
  };

  return (
    <Container fluid className="d-flex flex-column h-100 user-select-none">
      <div className="mt-2 d-none d-lg-block flex-shrink-0">
        <TabsHeader
          currentTabs={[currentTabIndex]}
          onTabChange={(newTab) => updateTabParam(newTab[0])}
          options={[
            ...[{ option: 'Role Details' }, { option: 'Permissions' }],
            ...(perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewAsRole'])
              ? [{ option: 'Dashboard View' }]
              : []),
          ]}
        />
      </div>
      <div className="mt-3 d-block d-lg-none flex-shrink-0">
        <MobileTabsHeader
          options={[
            ...[{ option: 'Role Details' }, { option: 'Permissions' }],
            ...(perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewAsRole'])
              ? [{ option: 'Dashboard View' }]
              : []),
          ]}
        />
      </div>
      <div className="d-flex flex-column flex-grow-1 overflow-auto mt-3">
        <div className="d-flex bg-base align-items-center justify-content-center flex-grow-1">
          {renderTab()}
        </div>
      </div>
      {result && (
        <div
          className="h4 fw-bold flex-shrink-0"
          style={{ color: result.type === 'success' ? 'green' : 'red' }}
        >
          {result.message}
        </div>
      )}
      <div className="d-flex flex-row justify-content-between mt-2 flex-shrink-0">
        <Button
          className="d-flex flex-row align-items-center bg-primary rounded-1"
          onClick={onBack}
        >
          <div className="d-flex align-items-center">
            <IconContext.Provider value={{ size: 20 }}>
              <FaChevronLeft />
            </IconContext.Provider>
          </div>
          <div className="me-1 fs-6 gap-2">{currentTabIndex === 0 ? 'Return' : 'Back'}</div>
        </Button>
        <Button
          className="d-flex flex-row align-items-center bg-primary rounded-1"
          onClick={onNext}
        >
          <div className="ms-1 fs-6 gap-2">
            {currentTabIndex === TAB_OPTIONS.length - 1 ? 'Return' : 'Next'}
          </div>
          <div className="d-flex align-items-center">
            <IconContext.Provider value={{ size: 20 }}>
              <FaChevronRight />
            </IconContext.Provider>
          </div>
        </Button>
      </div>
    </Container>
  );
}
